import { z } from "zod";
import { GroupJoinRequestDecision } from "../enum-group.js";

export const decideGroupJoinRequestSchema = z
	.object({
		decision: z.enum(GroupJoinRequestDecision),
	})
	.strict();

export type DecideGroupJoinRequestPayload = z.infer<typeof decideGroupJoinRequestSchema>;
